<template>
    <div v-if="Array.isArray(participants) && participants.length > 0">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" v-for="(participant, key) in participants">
            <transition-group name="list">
                <participant-block @confirmed="confirm" v-bind:participantId="participant" v-if="current == key" v-bind:key="key"></participant-block>
            </transition-group>
        </div>
    </div>

    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" v-else>
        <p class="text-center"><i class="fa fa-spinner fa-pulse fa-5x dark"></i></p>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                current: 0,
                participants: [],
                confirmed: [],
            }
        },
        components: {
            'participant-block': require('./ParticipantComplete.vue')
        },
        methods: {
            progress: function() {
                /**
                 * Obviously don't want to continue if there are errors.
                 */
                this.$validator.validateAll();
                if(this.errors.errors.length) {
                    return false;
                }
                this.$router.push({ name: 'cart.basket' });
            },
            confirm: function (participantId) {
                ++this.current;
                this.$root.alert("Thank you for confirming your child's details.", 'success');
                if(this.current == this.participants.length)
                    this.$router.push({ name: 'cart.payment'});
            }
        },
        created () {
            var participants = [];
            var items = [];
            axios.get('/camp-booking/bookings/' + this.$root.getCookie('kingscamps_booking_id') + '/items')
                .then(response => {
                    items = response.data.data;
                    participants = items.map(function(value,index) { if(value.booking_item_state_id != 4) return value.participant_id; });
                    var seen = {};
                    this.participants = participants.filter(function(item) {
                        return item != undefined && (seen.hasOwnProperty(item) ? false : (seen[item] = true));
                    });
                    if(this.participants.length == 0)
                        this.$router.push({ name: 'cart.payment'});
                })

        }
    }
</script>



// WEBPACK FOOTER //
// Participants.vue?5f1ba933